define('models/StoreCollection',['underscore', 'ObjectCollection', 'LocalStorage', 'models/StoreModel', 'ApiRequest'], function (_, ObjectCollection, LocalStorage, StoreModel, ApiRequest) {
    //
    // Collection Store
    //
    var StoreCollectionPrototype = {

        name: 'StoreCollection',
        route: 'apiStoreCollection',
        model: StoreModel,
        international:false,
        initialize: function () {
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this, arguments);
            //
        },
        setupInternational:function(){
            this.international = true;
        },
        getStoreExistInNeolane: function () {
            var stores = this.filter(function (store) {
                return store.get('id_neolane') !== 0;
            });

            return new StoreCollection(stores);
        },
        getCount:function(type_shop){
            return type_shop >= 0 ? this.filter(function(store){
                return store.get('type_shop') == type_shop;
            }).length : this.size();
        },
        findByPostcode: function (options, datetime) {
            var exclusion,
                isVAE = options.isVAE == true,
                stores = this.filter(function (store) {
                var intersects = store.intersectsOneOfThosePostcodes(options.id_postcode, datetime);
                if (intersects.length > 0) {

                    // la boutique peut ne pas être disponible en VAE
                    if(!store.isAvailable(isVAE)) return;

                    if (options.id_district) {
                        if (!store.hasDistricts()) {
                            // exception 1
                            // la boutique n'a pas de district, mais le code postal correspond
                            // ce résultat est valide
                            return true;
                        }
                        // datetime is optional
                        var districts = store.getZonesDatetime(datetime),
                            valid_district = _(_.pluck(districts, 'id_district')).contains(options.id_district);
                        return valid_district;
                    } else if (store.hasDistricts()) {
                        // exception 2
                        // si on a un district, et que la boutique n'en a pas, on concidère la boutique comme exclue
                        // ce résultat n'est pas valide,
                        // on le garde cependant en secour
                        // pour gérer des erreurs de configuration
                        exclusion = store;
                        return false;
                    }
                    return true;
                }
                return false;
            });
            if (stores.length == 0 && exclusion) {
                // gère des configurations qui sont peu logiques
                // on trouve une
                stores.push(exclusion);
            }
            return stores;
        },
        findByUrlRewrite: function(link_rewrite) {
            return this.findWhere(function(store){
                return store.get('link_rewrite') === link_rewrite;
            })
        },
        syncExceptionnalClosure: function(callback){
            var collection = this
            return ApiRequest('StoreClosure', {}, {id_store: ''}, {method: 'GET'}).done(function (data) {
                _(data).each(function(closure){
                    collection.get(closure.id_store).set('closure', closure)
                })
                collection.trigger('exceptionnalClosure', collection);
                if(callback) callback(data);
            }).fail(callback);
        }
    };

    var StoreCollection = ObjectCollection.extend(LocalStorage).extend(StoreCollectionPrototype);

    return StoreCollection;
});

